import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { OdometroHorimetroApiService } from "./shared/odometro-horimetro-api.service";
import { OdometroHorimetroService } from "./shared/odometro-horimetro.service";
import { OdometroHorimetroFormComponent } from "./odometro-horimetro-form/odometro-horimetro-form.component";
import { OdometroHorimetroLabelComponent } from "./odometro-horimetro-label/odometro-horimetro-label.component";

@NgModule({
    imports: [
        SharedModule
    ],
    providers: [
        OdometroHorimetroService,
        OdometroHorimetroApiService
    ],
    declarations: [
        OdometroHorimetroFormComponent,
        OdometroHorimetroLabelComponent
    ],
    exports: [
        OdometroHorimetroFormComponent,
        OdometroHorimetroLabelComponent
    ]
})
export class OdometrosHorimetrosModule { }


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/odometros-horimetros/odometros-horimetros.module.ts
 **/